import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../api/client";
import { toast } from "sonner";

export default function Signup() {
    const { register } = useAuth();
    const nav = useNavigate();
    const [form, setForm] = useState({ name: "", email: "", password: "" });
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await register(form.name, form.email, form.password);
            toast.success("Welcome to Globic India!");
            nav("/");
        } catch (e) {
            setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6 py-12 animate-fade-slide">
            <div className="w-full max-w-md bg-white border border-brand-line rounded-3xl p-8 md:p-10">
                <div className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange mb-2">Join the crunch</div>
                <h1 className="font-heading font-black text-4xl tracking-tighter mb-6">Create account</h1>
                <form onSubmit={submit} className="space-y-4">
                    {[
                        ["name", "Full name", "text"],
                        ["email", "Email", "email"],
                        ["password", "Password (min 6)", "password"],
                    ].map(([k, label, type]) => (
                        <div key={k}>
                            <label className="text-xs font-bold text-brand-moss mb-2 uppercase tracking-wider block">{label}</label>
                            <input
                                type={type}
                                required
                                minLength={type === "password" ? 6 : undefined}
                                value={form[k]}
                                onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                                data-testid={`signup-${k}`}
                                className="w-full bg-brand-cream border-none rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-brand-orange"
                            />
                        </div>
                    ))}
                    {error && <p data-testid="signup-error" className="text-sm text-destructive font-bold">{error}</p>}
                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="signup-submit"
                        className="w-full bg-brand-orange text-white font-bold py-4 rounded-xl btn-lift disabled:opacity-50"
                    >
                        {loading ? "Creating..." : "Create account"}
                    </button>
                </form>
                <p className="text-sm text-center mt-6 text-brand-moss">
                    Already a crunch enthusiast?{" "}
                    <Link to="/login" className="font-bold text-brand-orange hover:underline">
                        Sign in
                    </Link>
                </p>
            </div>
        </div>
    );
}
